import React, { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

export const StripeContext = createContext(null);

export const StripeContextProvider = ({ children, stripeKey }) => {
  const [stripe, setStripe] = useState(null);

  useEffect(() => {
    if (stripeKey) {
      const locale = SharedIntlProviderHOC.getLocale();
      const stripe = Stripe.StripeV3(stripeKey, { locale });

      setStripe(stripe);
    }
  }, [stripeKey]);

  return <StripeContext.Provider value={stripe}>
    {children}
  </StripeContext.Provider>;
};

StripeContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  stripeKey: PropTypes.string.isRequired
};
